'use client';
// it is required as there are components using `extend` prop which is not supported in server components
import React from 'react';
import type { TextT } from '@mentimeter/ragnar-ui/text';
import { Heading } from './Heading';

export const H1 = (props: TextT) => (
  <Heading as="h1" fontSize={['200', 7, 7, '300']} {...props} />
);
